import type { InvestorFirmAdminRead } from '@capital-markets-gateway/api-client-rolodex';
import { Banner } from '@cmg/common';
import { Alert, AlertTitle, Box, Typography } from '@cmg/design-system';
import React from 'react';

import type { Firm } from '../../../../../types/domain/firm/Firm';
import type { FirmMatchN1MappingData } from '../../../../../types/domain/firm-match/FirmMatchN1MappingData';

type HeaderWarningsProps = {
  firm: Firm | null;
  crmInvestorFirm: InvestorFirmAdminRead;
  linkTargetDisplayName: string | null;
  otherCrmFirmsLinkedToTarget: FirmMatchN1MappingData[];
};

export const LinkOrganizationHeaderWarnings: React.FC<HeaderWarningsProps> = ({
  firm,
  crmInvestorFirm,
  linkTargetDisplayName,
  otherCrmFirmsLinkedToTarget,
}) => (
  <Box>
    {firm && firm.isFirmMappedToCmgAccount && (
      <Banner variant="warning">
        This CMG Entity is linked to a CMG Account. Once linked, it cannot be revoked.
      </Banner>
    )}

    {otherCrmFirmsLinkedToTarget.length > 0 && linkTargetDisplayName && (
      <Alert severity="warning" data-testid="n-to-one-link-warning">
        <AlertTitle>Please review before proceeding</AlertTitle>
        <Typography variant="body2">
          {linkTargetDisplayName} is already linked to{' '}
          {otherCrmFirmsLinkedToTarget.length === 1 ? (
            otherCrmFirmsLinkedToTarget[0].name
          ) : (
            <Typography component="span">
              {otherCrmFirmsLinkedToTarget
                .slice(0, -1)
                .map(firmItem => firmItem.name)
                .join(', ')}{' '}
              and {otherCrmFirmsLinkedToTarget.slice(-1)[0].name}
            </Typography>
          )}
          . Are you sure you want to also link it to {crmInvestorFirm.name}?
        </Typography>
      </Alert>
    )}
  </Box>
);
